const ADMIN_TOKEN_KEY = 'adminTokenBeforeImpersonation';
const ADMIN_USER_KEY = 'adminUserBeforeImpersonation';

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user1'));
  } catch {
    return null;
  }
};

const getSavedAdminSession = () => {
  const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
  const userValue = sessionStorage.getItem(ADMIN_USER_KEY);
  if (!token || !userValue) return null;

  try {
    const user = JSON.parse(userValue);
    return user?.role === 'admin' ? { token, user } : null;
  } catch {
    return null;
  }
};

const clearSavedAdminSession = () => {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  sessionStorage.removeItem(ADMIN_USER_KEY);
};

export const isImpersonating = () => (
  getStoredUser()?.role === 'customer' &&
  Boolean(sessionStorage.getItem(ADMIN_TOKEN_KEY))
);

export const beginImpersonation = ({ token, user }) => {
  if (!token || !user || user.role !== 'customer') {
    throw new Error('The server returned an invalid customer session.');
  }
  if (isImpersonating()) {
    throw new Error('An impersonation session is already active in this tab.');
  }

  const adminUserValue = localStorage.getItem('user1');
  const adminUser = getStoredUser();
  const adminToken = localStorage.getItem('token1');
  if (!adminToken || !adminUser || adminUser.role !== 'admin') {
    throw new Error('An administrator session is required to access a customer account.');
  }

  clearSavedAdminSession();
  sessionStorage.setItem(ADMIN_TOKEN_KEY, adminToken);
  sessionStorage.setItem(ADMIN_USER_KEY, adminUserValue);
  localStorage.setItem('token1', token);
  localStorage.setItem('user1', JSON.stringify(user));
  window.dispatchEvent(new Event('authchange'));
};

export const restoreAdminSession = () => {
  const savedAdminSession = getSavedAdminSession();
  if (!savedAdminSession) return false;

  localStorage.setItem('token1', savedAdminSession.token);
  localStorage.setItem('user1', JSON.stringify(savedAdminSession.user));
  clearSavedAdminSession();
  window.dispatchEvent(new Event('authchange'));
  return true;
};
